import { Component, OnInit } from "@angular/core";
import {
  faSignInAlt,
  faKey,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import { Mdlusu } from "../modelos/mdlusu";
import { AutenticarService } from "../servicios/autenticar.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  icoEnt = faSignInAlt;
  icoClv = faKey;
  icoUsu = faUserTie;
  usuarios = new Mdlusu("", "", "", "");
  resul: boolean;
  xErro: string;
  vUsuar: string;
  vClave: string;

  constructor(
    private autenticaService: AutenticarService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.autenticaService.logout();
    this.vUsuar = "";
    this.vClave = "";
  }

  reset(): void {
    this.xErro = "";
    this.resul = false;
  }

  login(): void {
    if (this.vUsuar === "" || this.vClave === "") {
      // No se  ha indicado nada
    } else {
      this.resul = true;
      this.autenticaService
        .login(this.vUsuar, this.vClave)
        .subscribe((result) => {
          if (result === "IDENTIFICACION VALIDA") {
            if (this.autenticaService.isAdmin()) {
              //console.log("ES ADMIN");
              this.router.navigate(["/adminPanel"]);
              return;
            } else {
              this.resul = false;
              this.router.navigate(["/portada"]);
            }
          } else {
            this.xErro = result;
            this.resul = false;
          }
        });
    }
  }
}
